import { combineReducers } from 'redux';
import optimist from 'redux-optimist';
import drama from './drama';
import seo from './seo';
import purchase from './purchase';
import entities from './entities';
import ui from './ui';
import fetchedData from './fetchedData';
import deviceType from './deviceType';
import user from './user';
import channelList from './channelList';
import ssrData from './ssrData';

export default optimist(
  combineReducers({
    drama,
    seo,
    purchase,
    entities,
    ui,
    fetchedData,
    deviceType,
    user,
    channelList,
    ssrData,
  })
);
